import React, { useState } from "react";
import "../../assets/css/FAQ.css";
import Headerr from "../Footer/QuickLinks/Headerr";
import Footer from "../Footer/Footer";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const FAQ = ({ limit, showLayout = true }) => {
    const { t } = useTranslation();
    const [activeFaq, setActiveFaq] = useState(null);

    // ✅ Get FAQ data from i18n JSON
    const faqs = t("faq", { returnObjects: true });
    const dataToShow = limit ? faqs.slice(0, limit) : faqs;

    return (
        <>
            {showLayout && <Headerr />}

            {showLayout && (
                <div className="privacy-header">
                    <h1>FAQ</h1>
                    <p>
                        <Link to="/" className="breadcrumb-home">
                            {t("home")}
                        </Link>{" "}
                        / <span className="breadcrumb-current">FAQ</span>
                    </p>
                </div>
            )}

            <section className="faq-section">
                <h2 className="faq-heading">
                    {t("got_questions", "Got Questions? We've Got Answers!")}
                </h2>

                {dataToShow.map((item, index) => {
                    const isOpen = activeFaq === index;

                    return (
                        <div
                            key={index}
                            className={`faq-item ${isOpen ? "active" : ""}`}
                        >
                            <button
                                className="faq-question"
                                onClick={() =>
                                    setActiveFaq(isOpen ? null : index)
                                }
                            >
                                <span className="faq-q-text">
                                    <span className="faq-number">{index + 1}.</span>
                                    <span className="faq-text">{item.q}</span>
                                </span>
                                <span className="faq-icon">{isOpen ? "−" : "+"}</span>
                            </button>

                            <div className="faq-answer"> 
                                <p>{item.a.p}</p>
                                <ul>
                                    {item.a.li.map((text, i) => (
                                        <li key={i}>{text}</li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                    );
                })}
            </section>

            {showLayout && <Footer />}
        </>
    );
};

export default FAQ;
